import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

import css from './Results.module.scss';

const PERCENT_ANIMATION_DELAY = 0.45;
const PERCENT_ANIMATION_DURATION = 0.85;

const AnimatedPercent: React.FC<{ value: number }> = ({ value }) => {
  const numberRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = numberRef.current;
    if (!el) {
      return;
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      el.textContent = String(value);
      return;
    }

    const state = { val: 0 };
    el.textContent = '0';

    const tween = gsap.to(state, {
      val: value,
      duration: PERCENT_ANIMATION_DURATION,
      delay: PERCENT_ANIMATION_DELAY,
      ease: 'power3.out',
      onUpdate: () => {
        el.textContent = String(Math.round(state.val));
      },
    });

    return () => {
      tween.kill();
    };
  }, [value]);

  return (
    <div className={css.percents}>
      <span className={css.percentValue} ref={numberRef}>
        0
      </span>
      <span>%</span>
    </div>
  );
};

export default AnimatedPercent;
